export default __webpack_public_path__ + "static/media/content-chat.64c98286.svg";